import React from "react";
import {
  Image,
  ImageBackground,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import { useDispatch } from "react-redux";

import { isPortrait } from "../../../utils/common";
import {
  AvatarModalPng,
  InviteBckd,
  InvitePlus,
  ProfileScore,
} from "../../../assets";
import { useDevice } from "../../../utils/hooks/useDevice";

const PlayerCard = () => {
  const dispatch = useDispatch();
  const { isMobile } = useDevice();

  return (
    <TouchableOpacity activeOpacity={0.8} style={{ borderRadius: 12 }}>
      <ImageBackground
        source={InviteBckd}
        resizeMode="stretch"
        style={[
          styles.cardBackground,
          {
            paddingRight: isPortrait ? 12 : 0,
          },
        ]}
      >
        <View
          style={[
            styles.container,
            {
              gap: isPortrait ? 8 : 10,
              marginLeft: isPortrait ? 8 : 6,
            },
          ]}
        >
          <View
            style={[
              styles.avatarWrapper,
              {
                width: isPortrait ? 110 : 120,
                marginLeft: isPortrait ? -36 : -10,
              },
            ]}
          >
            <ImageBackground
              source={AvatarModalPng}
              style={{
                width: isMobile ? 76 : 60,
                height: isPortrait ? 56 : 60,
                position: "relative",
                left: isPortrait ? -14 : -38,
                top: isPortrait ? 0 : -5,
              }}
              resizeMode="contain"
            />
            {/* <Image
              source={ProfileScore}
              style={[
                styles.scoreBadge,
                {
                  width: isPortrait ? 28 : 26,
                  height: isPortrait ? 32 : 26,
                  top: isPortrait ? 14 : 15,
                  left: isPortrait ? 50 : 36,
                },
              ]}
              resizeMode="contain"
            />
            <Text
              style={[
                styles.scoreText,
                {
                  top: isPortrait ? 26 : 36,
                  left: isPortrait ? 86 : 98,
                  fontSize: isPortrait ? 14 : 18,
                },
              ]}
            ></Text> */}
          </View>

          {/* <View
            style={[styles.statsItem, { marginRight: isPortrait ? 0 : 20 }]}
          >
            <Text
              style={[
                styles.nameText,
                {
                  fontSize: isPortrait ? 14 : 20,
                },
              ]}
            >
              Invite player
            </Text>
            <Image
              source={InvitePlus}
              resizeMode="contain"
              style={styles.plusIcon}
            />
          </View> */}
        </View>
      </ImageBackground>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  cardBackground: {
    borderRadius: 12,
    marginBottom: 6,
    marginLeft: 16,
    height: 52,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  avatarWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  scoreBadge: {
    position: "absolute",
  },
  scoreText: {
    width: 38,
    height: 38,
    position: "absolute",
    color: "#fff",
    fontWeight: "600",
  },
  nameText: {
    flex: 1,
    color: "white",
    fontWeight: "500",
    marginLeft: 3,
    textTransform: "uppercase",
  },
  statsItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  plusIcon: {
    width: 48,
    height: 48,
  },
});

export default PlayerCard;
